import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addBookingsToMultiServiceBookingRequest = {};
var _addBookingsToMultiServiceBookingResponse = {
    bookings: '_bookingResult',
};
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _bookingResult = { booking: '_v2Booking' };
var _bulkBookingResult = { item: '_v2Booking' };
var _bulkCalculateAllowedActionsRequest = {};
var _bulkCalculateAllowedActionsResponse = {};
var _bulkConfirmOrDeclineBookingRequest = {};
var _bulkConfirmOrDeclineBookingResponse = { results: '_bulkBookingResult' };
var _bulkCreateBookingRequest = { createBookingsInfo: '_createBookingInfo' };
var _bulkCreateBookingResponse = { results: '_bulkBookingResult' };
var _bulkGetMultiServiceBookingAllowedActionsRequest = {};
var _bulkGetMultiServiceBookingAllowedActionsResponse = {};
var _bulkRescheduleBookingRequest = {};
var _bulkRescheduleBookingResponse = {};
var _bulkUpdateBookedScheduleRequest = {};
var _bulkUpdateBookedScheduleResponse = {};
var _bulkUpdateBookingRequest = { bookings: '_maskedBooking' };
var _bulkUpdateBookingResponse = {};
var _calculateAllowedActionsRequest = {};
var _calculateAllowedActionsResponse = {};
var _cancelBookingRequest = {};
var _cancelBookingResponse = { booking: '_v2Booking' };
var _cancelMultiServiceBookingRequest = {};
var _cancelMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _confirmBookingRequest = {};
var _confirmBookingResponse = { booking: '_v2Booking' };
var _confirmMultiServiceBookingRequest = {};
var _confirmMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _confirmOrDeclineBookingRequest = {};
var _confirmOrDeclineBookingResponse = { booking: '_v2Booking' };
var _consistentQueryBookingsRequest = {};
var _consistentQueryBookingsResponse = { bookings: '_v2Booking' };
var _countBookingsRequest = {};
var _countBookingsResponse = {};
var _createBookingInfo = { booking: '_v2Booking' };
var _createBookingRequest = { booking: '_v2Booking' };
var _createBookingResponse = { booking: '_v2Booking' };
var _createMultiServiceBookingRequest = { bookings: '_v2Booking' };
var _createMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _declineBookingRequest = {};
var _declineBookingResponse = { booking: '_v2Booking' };
var _declineMultiServiceBookingRequest = {};
var _declineMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _getMultiServiceBookingAvailabilityRequest = {};
var _getMultiServiceBookingAvailabilityResponse = {};
var _getMultiServiceBookingRequest = {};
var _getMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _getScheduleAvailabilityRequest = {};
var _getScheduleAvailabilityResponse = {};
var _getSlotAvailabilityRequest = {};
var _getSlotAvailabilityResponse = {};
var _legacyCreateBookingRequest = { booking: '_v2Booking' };
var _legacyCreateBookingResponse = { booking: '_v2Booking' };
var _markAsMultiServiceBookingRequest = {};
var _markAsMultiServiceBookingResponse = {};
var _markBookingAsPendingRequest = {};
var _markBookingAsPendingResponse = { booking: '_v2Booking' };
var _markMultiServiceBookingAsPendingRequest = {};
var _markMultiServiceBookingAsPendingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _maskedBooking = {
    mask: 'google.protobuf.FieldMask',
    booking: '_v2Booking',
};
var _multiServiceBooking = { bookings: '_bookingResult' };
var _partySizeRequest = {};
var _partySizeResponse = {};
var _queryBookingsRequest = {};
var _queryBookingsResponse = { bookings: '_v2Booking' };
var _removeBookingsFromMultiServiceBookingRequest = {};
var _removeBookingsFromMultiServiceBookingResponse = {
    bookings: '_bookingResult',
};
var _rescheduleBookingRequest = {};
var _rescheduleBookingResponse = { booking: '_v2Booking' };
var _rescheduleMultiServiceBookingRequest = {};
var _rescheduleMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _setBookingSessionIdRequest = {};
var _setBookingSessionIdResponse = { booking: '_v2Booking' };
var _updateBookingRequest = {
    mask: 'google.protobuf.FieldMask',
    booking: '_v2Booking',
};
var _updateBookingResponse = { booking: '_v2Booking' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = {};
var _updateNumberOfParticipantsRequest = {};
var _updateNumberOfParticipantsResponse = { booking: '_v2Booking' };
var _v2Booking = {
    createdDate: 'google.protobuf.Timestamp',
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    canceledDate: 'google.protobuf.Timestamp',
    contactDetails: '_v2ContactDetails',
};
var _v2CancelBookingRequest = {};
var _v2CancelBookingResponse = { booking: '_v2Booking' };
var _v2ConfirmBookingRequest = {};
var _v2ConfirmBookingResponse = { booking: '_v2Booking' };
var _v2ContactDetails = { fullAddress: '_address' };
var _v2CreateBookingRequest = { contactDetails: '_v2ContactDetails' };
var _v2CreateBookingResponse = { booking: '_v2Booking' };
var _v2DeclineBookingRequest = {};
var _v2DeclineBookingResponse = { booking: '_v2Booking' };
var _v2RescheduleBookingRequest = {};
var _v2RescheduleBookingResponse = { booking: '_v2Booking' };
var _v2UpdateNumberOfParticipantsRequest = {};
var _v2UpdateNumberOfParticipantsResponse = { booking: '_v2Booking' };
function resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/bookings-service',
                destPath: '/v2/bookings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsBookingsV2BookingsUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/bookings-service',
                destPath: '/v2/bookings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-confirmator/v2/bookings/confirmation',
                destPath: '/v2/bookings/confirmation',
            },
            {
                srcPath: '/bookings/v2/confirmation',
                destPath: '/v2/confirmation',
            },
            {
                srcPath: '/bookings/v2/bulk/confirmation',
                destPath: '/v2/bulk/confirmation',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings/confirmOrDecline',
                destPath: '/v2/bulk/bookings/confirmOrDecline',
            },
            {
                srcPath: '/_api/bookings-confirmator/v2/bulk/confirmation',
                destPath: '/v2/bulk/confirmation',
            },
            {
                srcPath: '/_api/bookings-confirmator/v2/bulk/bookings/confirmOrDecline',
                destPath: '/v2/bulk/bookings/confirmOrDecline',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsGatewayV2BookingsGatewayUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-gateway/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-gateway/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-gateway/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings-gateway/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a booking.
 *
 *
 * To create a booking for an appointment or a session of a class, pass the
 * relevant `slot` in the body of the request. You can use the
 * [Get Slot Availability](https://bo.wix.com/wix-docs/rest/bookings/availabilitycalendar---wip/get-slot-availability)
 * endpoint to check the availability of the session beforehand.
 *
 * To create a booking for the entire course, pass the relevant `schedule` in
 * the body of the request. You can use the
 * [Get Schedule Availability](https://bo.wix.com/wix-docs/rest/bookings/availabilitycalendar---wip/get-schedule-availability)
 * endpoint to check the availability of the course beforehand.
 *
 * Bookings are created with a status of `CREATED`. `CREATED` bookings don't
 * appear on the business calendar and don't affect a related schedule's
 * availability.
 *
 * If you create a booking for an existing session, we recommend that you
 * only pass `slot.sessionId`. Then, any specified slot details are
 * calculated.
 *
 * If you create a booking for a new session, we recommend to call
 * [Get Slot Availability](https://bo.wix.com/wix-docs/rest/bookings/availabilitycalendar---wip/get-slot-availability)
 * first. Then, pass the retrieved `availability.slot` object in the body of
 * the Create Booking request.
 *
 * If you create a booking for a course, we recommend that you pass only
 * `schedule.scheduleId` and not the entire `schedule` object. Then, all
 * schedule details are automatically calculated.
 *
 * When creating a booking you must pass either `participantsChoices` or
 * `totalParticipants`. If you pass `participantsChoices`, all of the
 * provided choices must exist for the service. Otherwise the call returns an
 * `INVALID_SERVICE_CHOICES` error.
 *
 * When creating a booking, you can pass a `selectedPaymentOption`. This specifies
 * which payment method the customer intends to use. But it's possible for
 * them to later use another supported payment method.
 *
 * After you have created the booking, you can use the
 * [Wix eCommerce APIs](https://bo.wix.com/wix-docs/rest/ecommerce/checkout/introduction)
 * for the [checkout](https://bo.wix.com/wix-docs/rest/ecommerce/checkout/create-checkout)
 * and [order](https://bo.wix.com/wix-docs/rest/ecommerce/checkout/create-order-from-checkout)
 * steps of the payment flow.
 * @deprecated
 */
export function bookingsGatewayCreateBooking(payload) {
    var _a = serializer(_v2CreateBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2CreateBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsGatewayCreateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.CreateBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsGatewayCreateBooking.fromReq = fromReq;
    __bookingsGatewayCreateBooking.__isAmbassador = true;
    return __bookingsGatewayCreateBooking;
}
/**
 * Cancels a booking.
 *
 *
 * The booking status changes to `CANCELED`.
 *
 * If the booking was for an appointment, the corresponding session is
 * deleted from the business calendar.
 *
 * If the booking was for a class or course, the participants are removed
 * from the class session or the course. But the course or class session
 * remain on the business calendar.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the cancelation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case you want to cancel a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreCancellationPolicy` as `false`. This
 * ensures that the cancelation is validated against the service's cancelation
 * policy.
 * @deprecated
 */
export function cancelBooking(payload) {
    var _a = serializer(_cancelBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __cancelBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.CancelBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelBooking.fromReq = fromReq;
    __cancelBooking.__isAmbassador = true;
    return __cancelBooking;
}
/**
 * Reschedules a booking to a different slot or session.
 *
 *
 * You can only reschedule bookings for appointments or classes, you can't
 * reschedule course bookings.
 *
 * The old session is removed from the calendar and the new session is
 * added.
 *
 * If you reschedule a booking for a class session the new session must be an
 * existing session for the same class.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the rescheduling. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case the service has
 * [variants](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/introduction),
 * you can call this endpoint to update the booking's `totalParticipants` or `participantsChoices`. If you
 * provide `participantsChoices`, all of the provided choices must exist for
 * the service. Otherwise the call returns an `INVALID_SERVICE_CHOICES` error.
 * If you omit `participantsChoices` in the request, the existing choices are
 * kept and not replaced with an empty object.
 *
 * <!-- INTERNAL PERMISSION COMMENT:
 * You need to have the `BOOKINGS.NUMBER_OF_PARTICIPANTS_UPDATE` permission
 * to reschedule bookings including `participantsInfo`.
 * <!--END: INTERNAL PERMISSION COMMENT-->
 *
 * In case you want to reschedule a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreReschedulePolicy` as `false`. This
 * ensures that the rescheduling is validated against the service's rescheduling
 * policy.
 * @deprecated
 */
export function bookingsGatewayRescheduleBooking(payload) {
    var _a = serializer(_v2RescheduleBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2RescheduleBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsGatewayRescheduleBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.RescheduleBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsGatewayRescheduleBooking.fromReq = fromReq;
    __bookingsGatewayRescheduleBooking.__isAmbassador = true;
    return __bookingsGatewayRescheduleBooking;
}
/**
 * Confirms a booking request and changes the booking status to `CONFIRMED`.
 *
 *
 * Calling this endpoint doesn't check whether a slot or schedule is still
 * available at this time.
 *
 * You can only confirm bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`. You can read more about
 * [creating a service](https://dev.wix.com/api/rest/wix-bookings/services/service/create-service).
 *
 * For appointment services the slot may become unavailable, depending on the
 * [service's](https://dev.wix.com/api/rest/wix-bookings/services/service/service-object)
 * `policy.bookingApprovalPolicy.requestsAffectsAvailability`.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `participants.approvalStatus` to `APPROVED`.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the confirmation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * Bookings are automatically confirmed when the
 * service is configured to [automatically confirm](https://dev.wix.com/api/rest/wix-bookings/services/service/create-service)
 * bookings and the [eCommerce order](https://bo.wix.com/wix-docs/rest/ecommerce/checkout/create-order-from-checkout)
 * has been approved. The slot's or schedule's availabity is checked just
 * before confirming the booking as part of the automatic flow.
 * @deprecated
 */
export function confirmBooking(payload) {
    var _a = serializer(_confirmBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_confirmBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __confirmBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.ConfirmBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/confirm',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __confirmBooking.fromReq = fromReq;
    __confirmBooking.__isAmbassador = true;
    return __confirmBooking;
}
/**
 * Declines a `PENDING` booking request and changes the booking status to
 * `DECLINED`.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `participants.approvalStatus` to `DECLINED`.
 *
 * You can only decline bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`. You can read more about
 * [creating a service](https://dev.wix.com/api/rest/wix-bookings/services/service/create-service).
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the decline. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 * @deprecated
 */
export function declineBooking(payload) {
    var _a = serializer(_declineBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_declineBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __declineBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.DeclineBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/decline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __declineBooking.fromReq = fromReq;
    __declineBooking.__isAmbassador = true;
    return __declineBooking;
}
/**
 * Updates the number of participants for a booking.
 *
 *
 * You can only update the number of participants for class and course
 * bookings, you can't update it for appointment bookings.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `totalNumberOfParticipants`.
 *
 * When updating the number of participants for a booking you must pass either
 * `participantsChoices` or `totalParticipants`. If you pass `participantsChoices`
 * for services that have
 * [variants](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/introduction),
 * all of the provided choices must exist for the service. Otherwise, the
 * call returns an `INVALID_SERVICE_CHOICES` error.
 * @deprecated
 */
export function updateNumberOfParticipants(payload) {
    var _a = serializer(_updateNumberOfParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateNumberOfParticipantsResponse, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }).fromJSON;
    function __updateNumberOfParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.UpdateNumberOfParticipants',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/update_number_of_participants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateNumberOfParticipants.fromReq = fromReq;
    __updateNumberOfParticipants.__isAmbassador = true;
    return __updateNumberOfParticipants;
}
/**
 * Updates the booking `status` to `CONFIRMED`, `PENDING`, or `DECLINED` based
 * on the `paymentStatus` you provide, double booking conflicts, and whether
 * the service requires business approval.
 *
 *
 * Call this endpoint only when using a custom checkout page. Don't
 * call it when using a [Wix eCommerce checkout](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction).
 * In such cases, Wix automatically updates the booking status based on
 * the `paymentStatus` of the corresponding
 * [Wix eCommerce order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction).
 *
 * The booking `status` is set to `DECLINED` if both of the following conditions
 * are met:
 * + You provide `UNDEFINED`, `NOT_PAID`, `REFUNDED`, or `EXEMPT` as payment status.
 * + There is a double booking conflict.
 *
 * If only one or none of these conditions is met, `status` is set to `PENDING`
 * or `CONFIRMED` depending on whether the service requires business approval.
 *
 * If there is a double booking conflict, `doubleBooked` is set to `true`.
 *
 * There are small but important differences in confirmation behavior if the
 * booking was created with special `flowControlSettings`:
 * + If the booking's `flowControlSettings.skipAvailabilityValidation` was set to
 * `true`, the booking is never declined regardless of double booking conflicts.
 * Instead, it's marked `CONFIRMED` or `PENDING`, depending on whether the
 * service requires business approval.
 * + If the booking's `flowControlSettings.skipBusinessConfirmation` was set to
 * `true`, the booking skips `PENDING` status and is marked `CONFIRMED`
 * immediately.
 */
export function confirmOrDeclineBooking(payload) {
    var _a = serializer(_confirmOrDeclineBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_confirmOrDeclineBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __confirmOrDeclineBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.confirmator.v2.Confirmator.ConfirmOrDeclineBooking',
            url: resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl({
                protoPath: '/v2/confirmation/{bookingId}:confirmOrDecline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __confirmOrDeclineBooking.fromReq = fromReq;
    __confirmOrDeclineBooking.__isAmbassador = true;
    return __confirmOrDeclineBooking;
}
/**
 * Confirms or declines multiple bookings.
 *
 *
 * See [Confirm Or Decline Booking](/bookings-v2/bookings-v2-and-confirmation/bookings-confirm-or-decline-booking)
 * for details about when a booking is confirmed or declined.
 */
export function bulkConfirmOrDeclineBooking(payload) {
    var _a = serializer(_bulkConfirmOrDeclineBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkConfirmOrDeclineBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bulkBookingResult: _bulkBookingResult,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bulkConfirmOrDeclineBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.confirmator.v2.Confirmator.BulkConfirmOrDeclineBooking',
            url: resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl({
                protoPath: '/v2/bulk/bookings/confirmOrDecline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkConfirmOrDeclineBooking.fromReq = fromReq;
    __bulkConfirmOrDeclineBooking.__isAmbassador = true;
    return __bulkConfirmOrDeclineBooking;
}
/**
 * Creates a booking.
 *
 *
 * To create a booking for an appointment or a session of a class, pass a booking with the relevant `slot`.
 *
 * To create a booking for the entire course, pass a booking with the relevant `schedule`.
 * You can use the [Query Availability](https://dev.wix.com/api/rest/wix-bookings/availability-calendar/query-availability) endpoint to check the availability beforehand.
 *
 * If you create a booking for an existing session, we recommend that you only pass `slot.sessionId`.
 * Then, any specified slot details are calculated.
 *
 * If you create a booking for a new session, we recommend to call
 * [Query Availability](https://dev.wix.com/api/rest/wix-bookings/availability-calendar/query-availability)
 * first.
 * Then, pass the retrieved `availability.slot` object as the BookedEntity.Slot of the booking in the request.
 *
 * Bookings are created with a status of `CREATED`.
 * `CREATED` bookings don't appear on the business calendar and don't affect a related schedule's availability.
 *
 * To create a booking with a given status, pass a booking with the wanted status.
 * This is only permitted for site Owners.
 *
 * You can pass a `participantNotification.message` to notify the customer of the booking with a message.
 * It's also necessary to pass `participantNotification.notifyParticipants`as `true` to send the message.
 *
 * You can pass `sendSmsReminder` as `true`, if you want an SMS reminder to be sent to the phone number specified in the ContactDetails, 24 hours before the session starts.
 *
 * When creating a booking you must pass either `participantsChoices` or `totalParticipants`. If you pass `participantsChoices`, all the
 * provided choices must exist for the service, otherwise the call returns an `INVALID_SERVICE_CHOICES` error.
 *
 * When creating a booking, you can pass `selectedPaymentOption`.
 * This specifies which payment method the customer plans to use.
 * But it's possible for them to later use another supported payment method.
 *
 * You can skip the checkout and payment flow if you call [Confirm Or Decline Booking ](https://dev.wix.com/api/rest/wix-bookings/confirmation/confirm-or-decline-booking) otherwise, after you create the booking, you can use the
 * Wix eCommerce APIs (coming soon) for the checkout and payment flow or use a different service for checkout.
 */
export function createBooking(payload) {
    var _a = serializer(_createBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __createBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CreateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBooking.fromReq = fromReq;
    __createBooking.__isAmbassador = true;
    return __createBooking;
}
/** @deprecated */
export function updateBooking(payload) {
    var _a = serializer(_updateBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __updateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'PATCH',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.UpdateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{booking.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBooking.fromReq = fromReq;
    __updateBooking.__isAmbassador = true;
    return __updateBooking;
}
export function legacyCreateBooking(payload) {
    var _a = serializer(_legacyCreateBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_legacyCreateBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __legacyCreateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.LegacyCreateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/createBooking',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __legacyCreateBooking.fromReq = fromReq;
    __legacyCreateBooking.__isAmbassador = true;
    return __legacyCreateBooking;
}
/**
 * Updates a batch of bookings.
 * If any `fieldMask` contains `numberOfParticipants` and the field is not defined in the `request.booking` the update fails.
 * If any `fieldMask` contains `participantsInfo` and the field is not defined in the `request.booking` the update fails.
 * If any `fieldMask` contains both `numberOfParticipants` and `participantsInfo` the update fails.
 * If participantsChoices are provided, they are validated against the service variants.if not all choices exist in the variants list a INVALID_SERVICE_CHOICES error is returned.
 */
export function bulkUpdateBooking(payload) {
    var _a = serializer(_bulkUpdateBookingRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _maskedBooking: _maskedBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateBookingResponse, {}).fromJSON;
    function __bulkUpdateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'PATCH',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkUpdateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/bulk/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateBooking.fromReq = fromReq;
    __bulkUpdateBooking.__isAmbassador = true;
    return __bulkUpdateBooking;
}
/**
 * Creates multiple bookings.
 *
 *
 * See [Create Booking](https://dev.wix.com/api/rest/wix-bookings/bookings-v2/create-booking) documentation.
 * If for any of the bookings required fields were not passed on the request or if the caller doesn't have the required permissions to create such booking, the call fails.
 * If the request contains unavailable bookings, the call completes successfully but the unavailable bookings are not created and are not considered as failures in the response.
 */
export function bulkCreateBooking(payload) {
    var _a = serializer(_bulkCreateBookingRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _createBookingInfo: _createBookingInfo,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bulkBookingResult: _bulkBookingResult,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bulkCreateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkCreateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bulk/bookings/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateBooking.fromReq = fromReq;
    __bulkCreateBooking.__isAmbassador = true;
    return __bulkCreateBooking;
}
/**
 * Reschedules a booking to a different slot or session.
 *
 *
 * You can only reschedule bookings for appointments or classes, you can't
 * reschedule course bookings.
 *
 * The old session is removed from the calendar and the new session is
 * added.
 *
 * If you reschedule a booking for a class session the new session must be an
 * existing session for the same class.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the rescheduling. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case the service has
 * variants, you can call this endpoint to update the booking's `totalParticipants` or `participantsChoices`.
 * If you provide `participantsChoices`, all of the provided choices must exist for
 * the service. Otherwise, the call returns an `INVALID_SERVICE_CHOICES` error.
 * If you omit `participantsChoices` in the request, the existing choices are
 * kept and not replaced with an empty object.
 *
 * <!-- INTERNAL PERMISSION COMMENT:
 * You need to have the `BOOKINGS.NUMBER_OF_PARTICIPANTS_UPDATE` permission
 * to reschedule bookings including `participantsInfo`.
 * <!--END: INTERNAL PERMISSION COMMENT-->
 *
 * In case you want to reschedule a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreReschedulePolicy` as `false`. This
 * ensures that the rescheduling is validated against the service's rescheduling
 * policy.
 */
export function rescheduleBooking(payload) {
    var _a = serializer(_rescheduleBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rescheduleBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __rescheduleBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.RescheduleBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rescheduleBooking.fromReq = fromReq;
    __rescheduleBooking.__isAmbassador = true;
    return __rescheduleBooking;
}
export function bulkRescheduleBooking(payload) {
    var _a = serializer(_bulkRescheduleBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRescheduleBookingResponse, {}).fromJSON;
    function __bulkRescheduleBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkRescheduleBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/bulk/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRescheduleBooking.fromReq = fromReq;
    __bulkRescheduleBooking.__isAmbassador = true;
    return __bulkRescheduleBooking;
}
export function bulkUpdateBookedSchedule(payload) {
    var _a = serializer(_bulkUpdateBookedScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateBookedScheduleResponse, {}).fromJSON;
    function __bulkUpdateBookedSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkUpdateBookedSchedule',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/bulk/update_booked_schedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateBookedSchedule.fromReq = fromReq;
    __bulkUpdateBookedSchedule.__isAmbassador = true;
    return __bulkUpdateBookedSchedule;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with [Query Extended Bookings](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings) and will be removed on December 31, 2023.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves a list of bookings according to the provided filters and paging.
 *
 * <!-- Internal only
 * Site owner can read all the bookings created in the site.
 * Members can read only the bookings they created or the bookings created for them (which means: booking.contactDetails.contactId = memberId)
 * Visitors can read only the bookings they created or the bookings created for them (which means: booking.contactDetails.contactId = visitorId)
 * -->
 *
 * Create a query with filters on any booking object property.
 * See [Query Syntax: Filters, Sorting, Fields, and Paging.](https://bo.wix.com/wix-docs/rest/bookings/bookings---bookings-service/query-syntax) for the full query syntax description.
 *
 * To retrieve all bookings use an empty query:
 * ```javascript
 * {
 * "query": {}
 * }
 * ```
 *
 * The query runs with the following defaults:
 * + skip(0)
 * + limit(50)
 * + descending("_createdDate")
 *
 *
 * >**Notes:**
 * > + Use UTC when specifying filters with dates.
 * > + The following objects in the `query` parameter are not supported for this query:
 * >    - `fields`
 * >    - `fieldsets`
 * >  - Only 1 use at a time of each filter once in the same query is supported. If a filter is defined  more than once in a query, only the first occurrence is taken.
 * >  - To get the available actions for a member for each booking, based on the business bookings policy, use the `withBookingAllowedActions` field.
 * >  - When using the queryBookings() function immediately following a change to your bookings, the data retrieved may not contain your most recent changes. See [Wix-data and Eventual Consistency](reference/wix-data/introduction#wix-data_introduction_wix-data-and-eventual-consistency) for more information.
 * >  - The `businessLocation.businessSchedule` object in the `bookedEntity.location` object is not supported.
 *
 *
 * > **Permissions**
 * > This endpoint requires the Read Bookings - Including Participants permission scope.
 */
export function query(payload) {
    var _a = serializer(_queryBookingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBookingsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __query(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.Query',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __query.fromReq = fromReq;
    __query.__isAmbassador = true;
    return __query;
}
/**
 * Confirms a booking and changes the booking status to `CONFIRMED`.
 *
 *
 * You can only confirm bookings that have a status of `PENDING`, `CREATED`, or `WAITING_LIST`.
 *
 * Calling this endpoint doesn't check whether a slot or schedule is still
 * available at this time.
 *
 * For appointment services the slot may become unavailable, depending on the
 * [service's](https://dev.wix.com/api/rest/wix-bookings/services/service/service-object)
 * `policy.bookingApprovalPolicy.requestsAffectsAvailability`.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `participants.approvalStatus` to `APPROVED`.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the confirmation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 * If you don't define `participantNotification.message`, the participant notification for the booking defaults to the one specified when the booking was created.
 *
 * You can pass `sendSmsReminder` as `true` if you want an SMS reminder to be sent to the phone number specified in the `ContactDetails` 24 hours before the session starts.
 * If you don't define the reminder, the SMS reminder for the booking defaults to the one specified when the booking was created.
 *
 * If you provide `paymentStatus`, this status is applied to the booking. Otherwise, the payment status for the booking remains unchanged.
 *
 * Bookings are automatically confirmed when both of the following conditions are met:
 *
 * + The service is configured to [automatically confirm](https://dev.wix.com/api/rest/wix-bookings/services/service/create-service)
 * + The eCommerce (_coming soon_) order has been approved.
 *
 * The slot's or schedule's availability is checked just
 * before confirming the booking as part of the automatic flow.
 */
export function bookingsConfirmBooking(payload) {
    var _a = serializer(_v2ConfirmBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2ConfirmBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsConfirmBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.ConfirmBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/confirm',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsConfirmBooking.fromReq = fromReq;
    __bookingsConfirmBooking.__isAmbassador = true;
    return __bookingsConfirmBooking;
}
/** calculates the party sizes sum  of all the bookings to a requested session_id or schedule_id */
export function partySize(payload) {
    var _a = serializer(_partySizeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_partySizeResponse, {}).fromJSON;
    function __partySize(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.PartySize',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/party_size',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __partySize.fromReq = fromReq;
    __partySize.__isAmbassador = true;
    return __partySize;
}
/** private API, similarly to Query, with consistent DB connection */
export function consistentQuery(payload) {
    var _a = serializer(_consistentQueryBookingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_consistentQueryBookingsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __consistentQuery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.ConsistentQuery',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/consistent_query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __consistentQuery.fromReq = fromReq;
    __consistentQuery.__isAmbassador = true;
    return __consistentQuery;
}
/** Private API, dedicated for setting booking sessionId after the session was created for the booking. */
export function setBookingSessionId(payload) {
    var _a = serializer(_setBookingSessionIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setBookingSessionIdResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __setBookingSessionId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.SetBookingSessionId',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{id}/set_booking_session_id',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setBookingSessionId.fromReq = fromReq;
    __setBookingSessionId.__isAmbassador = true;
    return __setBookingSessionId;
}
/**
 * Updates the extended fields for a booking.
 *
 *
 * Extended fields must first be configured in the app dashboard.
 *
 * Learn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).
 */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {}).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.UpdateExtendedFields',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{id}/update_extended_fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/**
 * Declines a booking and changes the booking status to `DECLINED`.
 *
 *
 * You can only decline bookings that have a status of `PENDING`, `CREATED`, or `WAITING_LIST`.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `participants.approvalStatus` to `DECLINED`.
 *
 * You can only decline bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the decline. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * If you provide `paymentStatus`, this status is applied to the booking. Otherwise, the payment status for the booking remains unchanged.
 */
export function bookingsDeclineBooking(payload) {
    var _a = serializer(_v2DeclineBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2DeclineBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsDeclineBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.DeclineBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/decline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsDeclineBooking.fromReq = fromReq;
    __bookingsDeclineBooking.__isAmbassador = true;
    return __bookingsDeclineBooking;
}
/**
 * Cancels a booking.
 *
 *
 * The booking status changes to `CANCELED`.
 *
 * If the booking was for an appointment, the corresponding session is
 * deleted from the business calendar.
 *
 * If the booking was for a class or course, the participants are removed
 * from the class session or the course. But the course or class session
 * remains on the business calendar.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the cancelation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case you want to cancel a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreCancellationPolicy` as `false`. This
 * ensures that the cancelation is validated against the service's cancelation
 * policy.
 */
export function bookingsCancelBooking(payload) {
    var _a = serializer(_v2CancelBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2CancelBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsCancelBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CancelBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsCancelBooking.fromReq = fromReq;
    __bookingsCancelBooking.__isAmbassador = true;
    return __bookingsCancelBooking;
}
/**
 * Updates the number of participants for a booking.
 *
 *
 * You can only update the number of participants for class and course
 * bookings, you can't update it for appointment bookings.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `totalNumberOfParticipants`.
 *
 * When updating the number of participants for a booking you must pass either
 * `participantsChoices` or `totalParticipants`. If you pass `participantsChoices`
 * for services that have variants,
 * all of the provided choices must exist for the service. Otherwise, the
 * call returns an `INVALID_SERVICE_CHOICES` error.
 */
export function bookingsUpdateNumberOfParticipants(payload) {
    var _a = serializer(_v2UpdateNumberOfParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2UpdateNumberOfParticipantsResponse, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }).fromJSON;
    function __bookingsUpdateNumberOfParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.UpdateNumberOfParticipants',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/update_number_of_participants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsUpdateNumberOfParticipants.fromReq = fromReq;
    __bookingsUpdateNumberOfParticipants.__isAmbassador = true;
    return __bookingsUpdateNumberOfParticipants;
}
/** Calculates the allowed actions for a given booing by id */
export function calculateAllowedActions(payload) {
    var _a = serializer(_calculateAllowedActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculateAllowedActionsResponse, {}).fromJSON;
    function __calculateAllowedActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CalculateAllowedActions',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/calculate_allowed_actions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculateAllowedActions.fromReq = fromReq;
    __calculateAllowedActions.__isAmbassador = true;
    return __calculateAllowedActions;
}
/** Calculates the allowed actions for a given list of booking id's */
export function bulkCalculateAllowedActions(payload) {
    var _a = serializer(_bulkCalculateAllowedActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCalculateAllowedActionsResponse, {}).fromJSON;
    function __bulkCalculateAllowedActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkCalculateAllowedActions',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bulk/bookings/calculate_allowed_actions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCalculateAllowedActions.fromReq = fromReq;
    __bulkCalculateAllowedActions.__isAmbassador = true;
    return __bulkCalculateAllowedActions;
}
export function getSlotAvailability(payload) {
    var _a = serializer(_getSlotAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSlotAvailabilityResponse, {}).fromJSON;
    function __getSlotAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.GetSlotAvailability',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/get_slot_availability',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSlotAvailability.fromReq = fromReq;
    __getSlotAvailability.__isAmbassador = true;
    return __getSlotAvailability;
}
/**
 * Returns availability for a given schedule ID
 * The availability for a course is calculated by:
 * - Checking for total spots by the schedule's capacity
 * - Checking for open spots by subtracting the current number of participants from the total spots
 */
export function getScheduleAvailability(payload) {
    var _a = serializer(_getScheduleAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getScheduleAvailabilityResponse, {}).fromJSON;
    function __getScheduleAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.GetScheduleAvailability',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{scheduleId}/get_schedule_availability',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getScheduleAvailability.fromReq = fromReq;
    __getScheduleAvailability.__isAmbassador = true;
    return __getScheduleAvailability;
}
export function markBookingAsPending(payload) {
    var _a = serializer(_markBookingAsPendingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markBookingAsPendingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __markBookingAsPending(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.MarkBookingAsPending',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/mark_booking_as_pending',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markBookingAsPending.fromReq = fromReq;
    __markBookingAsPending.__isAmbassador = true;
    return __markBookingAsPending;
}
/** Returns the count of bookings based on the given filters */
export function countBookings(payload) {
    var _a = serializer(_countBookingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countBookingsResponse, {}).fromJSON;
    function __countBookings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CountBookings',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countBookings.fromReq = fromReq;
    __countBookings.__isAmbassador = true;
    return __countBookings;
}
/**
 * Creates multi service booking.
 *
 * See [Create Booking](/bookings-v2/bookings-v2-and-confirmation/bookings-create-booking) documentation.
 */
export function createMultiServiceBooking(payload) {
    var _a = serializer(_createMultiServiceBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __createMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.CreateMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMultiServiceBooking.fromReq = fromReq;
    __createMultiServiceBooking.__isAmbassador = true;
    return __createMultiServiceBooking;
}
/**
 * Reschedules the multi service booking.
 * Validates all the bookings were passed.
 * Throws an exception if there is reschedule policy violation for any of the bookings or if the requested slots are not available.
 * See [Reschedule Booking](https://dev.wix.com/api/rest/wix-bookings/bookings-v2/reschedule-booking) documentation.
 */
export function rescheduleMultiServiceBooking(payload) {
    var _a = serializer(_rescheduleMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rescheduleMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __rescheduleMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.RescheduleMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rescheduleMultiServiceBooking.fromReq = fromReq;
    __rescheduleMultiServiceBooking.__isAmbassador = true;
    return __rescheduleMultiServiceBooking;
}
/**
 * Get multi service booking availability.
 * If the multi service booking is of type SEQUENTIAL_BOOKINGS, its availability is checked through ListMultiServiceAvailabilityTimeSlots API.
 */
export function getMultiServiceBookingAvailability(payload) {
    var _a = serializer(_getMultiServiceBookingAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMultiServiceBookingAvailabilityResponse, {}).fromJSON;
    function __getMultiServiceBookingAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.GetMultiServiceBookingAvailability',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/get_availability',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMultiServiceBookingAvailability.fromReq = fromReq;
    __getMultiServiceBookingAvailability.__isAmbassador = true;
    return __getMultiServiceBookingAvailability;
}
/**
 * Cancels the multi service booking.
 * Each booking within this multi service booking is being canceled.
 */
export function cancelMultiServiceBooking(payload) {
    var _a = serializer(_cancelMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __cancelMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.CancelMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelMultiServiceBooking.fromReq = fromReq;
    __cancelMultiServiceBooking.__isAmbassador = true;
    return __cancelMultiServiceBooking;
}
/**
 * Mark the multi service booking as PENDING.
 * Changes the status of each of the bookings within the multi service booking to PENDING
 * Validates all the bookings were passed.
 * See [MarkBookingAsPending](https://dev.wix.com/api/rest/wix-bookings/bookings-v2/mark-booking-as-pending) documentation.
 */
export function markMultiServiceBookingAsPending(payload) {
    var _a = serializer(_markMultiServiceBookingAsPendingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markMultiServiceBookingAsPendingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __markMultiServiceBookingAsPending(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.MarkMultiServiceBookingAsPending',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/mark_as_pending',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markMultiServiceBookingAsPending.fromReq = fromReq;
    __markMultiServiceBookingAsPending.__isAmbassador = true;
    return __markMultiServiceBookingAsPending;
}
/**
 * Confirms the multi service booking.
 * Each booking within this multi service booking is being confirmed.
 * Validates all the bookings were passed.
 * See [Confirm Booking](https://dev.wix.com/api/rest/wix-bookings/bookings-v2/confirm-booking) documentation.
 */
export function confirmMultiServiceBooking(payload) {
    var _a = serializer(_confirmMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_confirmMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __confirmMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.ConfirmMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/confirm',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __confirmMultiServiceBooking.fromReq = fromReq;
    __confirmMultiServiceBooking.__isAmbassador = true;
    return __confirmMultiServiceBooking;
}
/**
 * Declines the multi service booking.
 * Each booking within this multi service booking is being declined.
 * Validates all the bookings were passed.
 * See [Decline Booking](https://dev.wix.com/api/rest/wix-bookings/bookings-v2/decline-booking) documentation.
 */
export function declineMultiServiceBooking(payload) {
    var _a = serializer(_declineMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_declineMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __declineMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.DeclineMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/decline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __declineMultiServiceBooking.fromReq = fromReq;
    __declineMultiServiceBooking.__isAmbassador = true;
    return __declineMultiServiceBooking;
}
/** Get the allowed actions for a given multi service bookings by a list of multi service booking ids */
export function bulkGetMultiServiceBookingAllowedActions(payload) {
    var _a = serializer(_bulkGetMultiServiceBookingAllowedActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetMultiServiceBookingAllowedActionsResponse, {}).fromJSON;
    function __bulkGetMultiServiceBookingAllowedActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.BulkGetMultiServiceBookingAllowedActions',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetMultiServiceBookingAllowedActions.fromReq = fromReq;
    __bulkGetMultiServiceBookingAllowedActions.__isAmbassador = true;
    return __bulkGetMultiServiceBookingAllowedActions;
}
/**
 * Mark multiple existing bookings as multi service booking.
 * Throws if one of the bookings are already part of multi service booking.
 */
export function markAsMultiServiceBooking(payload) {
    var _a = serializer(_markAsMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsMultiServiceBookingResponse, {}).fromJSON;
    function __markAsMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.MarkAsMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/mark_as_multi_service_booking',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsMultiServiceBooking.fromReq = fromReq;
    __markAsMultiServiceBooking.__isAmbassador = true;
    return __markAsMultiServiceBooking;
}
/**
 * Retrieves the bookings of a given multi service booking id.
 * In case the caller have permissions to read only part of a bookings, only the permitted bookings would be
 * retrieved, but the total amount of bookings would be returned on response.
 */
export function getMultiServiceBooking(payload) {
    var _a = serializer(_getMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __getMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.GetMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMultiServiceBooking.fromReq = fromReq;
    __getMultiServiceBooking.__isAmbassador = true;
    return __getMultiServiceBooking;
}
/** Adds existing bookings to a multi service booking. */
export function addBookingsToMultiServiceBooking(payload) {
    var _a = serializer(_addBookingsToMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addBookingsToMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __addBookingsToMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.AddBookingsToMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addBookingsToMultiServiceBooking.fromReq = fromReq;
    __addBookingsToMultiServiceBooking.__isAmbassador = true;
    return __addBookingsToMultiServiceBooking;
}
/**
 * Removes existing bookings from a multi service booking.
 * If request.bookings is empty, all the bookings that the caller is authorized to read will be removed from the multi booking service.
 * Otherwise only the bookings in the request will be removed.
 * Throws an exception if the multi booking service is not found or one of the bookings in the request if present.
 * If the removal of the bookings was successful, the response will contain the bookings that were removed.
 * In case that the removal of the bookings will result in a multi bookings service with only one booking, the multi booking service will be deleted,
 * meaning also the last booking will be removed from the multi booking service.
 */
export function removeBookingsFromMultiServiceBooking(payload) {
    var _a = serializer(_removeBookingsFromMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeBookingsFromMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __removeBookingsFromMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.RemoveBookingsFromMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/remove_bookings_from_multi_service_booking',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeBookingsFromMultiServiceBooking.fromReq = fromReq;
    __removeBookingsFromMultiServiceBooking.__isAmbassador = true;
    return __removeBookingsFromMultiServiceBooking;
}
//# sourceMappingURL=http.impl.js.map